import request from './axiosInstance';
import axios from 'axios';

// Only signed part PUTs use the plain client: never send the account JWT to Spaces.
// The server remembers uploaded parts, so selecting the same files resumes them.
export async function uploadAudio(artId, rows, label, chapterPlan, onProgress, controller) {
  const signal = controller.signal;
  const config = { signal, timeout: 180000 };
  const start = await request.post(`/arts/${artId}/audio/uploads`, {
    label, chapterPlan,
    files: rows.map(({ file }) => ({ name: file.name, size: file.size, modified: file.lastModified || 0 })),
  }, config);
  if (start.data.book) return start.data.book;
  const id = start.data.id;
  const total = rows.reduce((n, r) => n + r.file.size, 0);
  const loaded = new Map();
  const report = () => onProgress(Math.min(100, Math.floor([...loaded.values()].reduce((a, b) => a + b, 0) / total * 100)));
  let next = 0;
  const worker = async () => {
    while (next < rows.length) {
      const index = next++;
      const { file } = rows[index];
      const endpoint = `/audio/uploads/${id}/files/${index}`;
      const status = (await request.get(endpoint, config)).data;
      loaded.set(`${index}:saved`, status.uploaded || 0); report();
      if (status.complete) continue;
      for (const part of status.parts) {
        const key = `${index}:${part.number}`;
        for (let attempt = 0; ; attempt++) {
          try {
            await axios.put(part.url, file.slice(part.start, part.start + part.size), {
              signal, timeout: 180000,
              onUploadProgress: e => { loaded.set(key, Math.min(part.size, e.loaded)); report(); },
            });
            loaded.set(key, part.size); report(); break;
          } catch (e) {
            loaded.set(key, 0); report();
            if (signal.aborted || attempt >= 2 || (e.response?.status >= 400 && e.response?.status < 500)) throw e;
            await new Promise(resolve => setTimeout(resolve, 1000 * (attempt + 1)));
          }
        }
      }
      await request.post(endpoint, {}, config);
    }
  };
  try {
    await Promise.all([worker(), worker()]);
    return (await request.post(`/audio/uploads/${id}/finish`, {}, config)).data;
  } catch (e) { controller.abort(); throw e; }
}
